module.exports = __webpack_public_path__ + "static/media/Campaigns.da01f30c.svg";